define('app/sdc/md/theming/sdc-md-theming',["$mdTheming"], function ($mdTheming) {
	return {
		restrict: "AE",
		template: null,
		scope: false,
		link: ["$scope", "$element", function (scope, element) {
			debugger;
			$mdTheming(scope, element);
		}]
	}
});
